export default __webpack_public_path__ + "static/media/Employees_Dizziness Handicap Inventory.cf292328.pdf";